/**
 * Universal Location Input - Main Export
 * Consolidates 15+ duplicate address/location components into one universal component
 */

export { default as UniversalLocationInput } from './UniversalLocationInput/index';

// Export types for TypeScript users
export type { 
  UniversalLocationInputProps, 
  UniversalLocationData
} from './UniversalLocationInput/types';

// Export utility functions for advanced usage
export { 
  getComponentConfig,
  parseGooglePlaceData,
  validateLocationData,
  formatLocationDisplay,
  isLocationDataComplete,
  mergeLocationData
} from './UniversalLocationInput/utils';

// Export backward compatibility wrappers
export {
  GooglePlacesAddressForm,
  AddressFieldSet,
  GoogleAddressAutoComplete,
  AddressEditCard,
  GooglePlacesSearch,
  LocationSearch,
  AddressFields
} from './UniversalLocationInput/wrappers';

// Export backward compatibility types
export type {
  GoogleAddressFields,
  GooglePlacesAddressFormProps,
  AddressFieldSetProps,
  GoogleAddressAutoCompleteProps,
  AddressEditCardProps,
  GooglePlacesSearchProps,
  LocationSearchProps,
  AddressFieldsProps
} from './UniversalLocationInput/wrappers';